module.exports = __webpack_public_path__ + "a.no2.815a32b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/a.no2.jpg
// module id = 0Dg+
// module chunks = 0